import CardSection from "./default";
export default CardSection;
